import React from 'react';
import classnames from 'classnames';

import Icon from 'assets/icons';
import { SharingRefetchQuery } from 'services';

import styles from './SharingToast.module.scss';
import { ToastContainerProps } from 'react-toastify';
import { useQuery } from '@apollo/react-hooks';

interface SharingToastProps extends ToastContainerProps {
  message: string;
  hasCloseButton?: boolean;
  closeToast?: () => void;
  nodeId: string;
  groupsEnabled: boolean;
}

export const SharingToast: React.FC<SharingToastProps> = ({
  message,
  hasCloseButton,
  closeToast,
  nodeId,
  groupsEnabled,
}) => {
  useQuery(SharingRefetchQuery, {
    variables: { nodeId: nodeId, includeGroups: groupsEnabled },
    context: { nodeIdForShareTargets: nodeId },
    fetchPolicy: 'network-only',
  });
  return (
    <div className={classnames(styles.container)}>
      <div className={styles.message}>{message}</div>

      {hasCloseButton && (
        <Icon.Close className={classnames(styles.close, styles.clickable)} onClick={closeToast} />
      )}
    </div>
  );
};
